<template>
	<div class="heart-rate-history">
		<list
			:loading.sync="loading"
			:show-more="false"
			:list="list"
			:finished="finished"
			@load="getList"
			@onUpdate="clickEdit"
		/>
	</div>
</template>
<script>
import list from './components/history-list.vue'
import MixinList from './mixins/list'
export default {
    name: 'historyList',
    components: { list },
    mixins: [MixinList],
    mounted () {

    },
    methods: {
        load () {
            this.getList()
        },
        // 获取历史记录
        async getList () {
            this.loading = true
            const res = await this.$api.indicator.bloodFatPage({
                patientId: this.patientId,
                page: this.page,
                limit: this.limit
            })
            this.loading = false
            if (!res.code) {
                let arr = res.data.list.map(v => ({
                    ...v,
                    list: [
                        {
                            label: '甘油三酯mmol/L',
                            number: v.triglycerides,
                            status: this.$status.bloodStatus[v.triglyceridesStatus]
                        },
                        {
                            label: '低密度脂蛋白胆固醇mmol/L',
                            number: v.lowDensityFat,
                            status: this.$status.bloodStatus[v.lowDensityFatStatus]
                        }
                    ],
                    time: this.$moment(v.measureTime).format('HH:mm'),
                }))
                this.list = this.initList(this.list, arr)
                this.total = res.data.total
                this.page++
            }
        },
        clickEdit (val) {
            this.$router.push(`/indicator/bloodFat/edit/${val.id}`)
        },
    }
}
</script>
<style lang="less">
</style>